import { gsap } from "gsap";
import { SplitText } from "../../plugins/gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

class PageHomepage {
    constructor(el) {
        this.page = el;
        this.contentSections = document.querySelectorAll(".data-content-on-scroll");
        this.initAnimation()
        this.typewriterAnimtion()
        this.initScrollAnimation()
    }

    initAnimation() {
        gsap.set(['#homepage-content h1', '.home-intro'], {alpha: 1});
        // gsap.set('.home-intro p', {z:-400,force3D: true,transformStyle: "preserve-3d", transformOrigin: "center bottom", y: 50, rotationX: "-90deg"})
        // gsap.timeline({delay: 1})
        //     .to('.home-intro p', {duration: 1,y:0,z:0,rotationX:'0deg',force3D: true,stagger: {
        //             each:0.1,
        //         },
        //         ease: "expo.out"})
        gsap.set('.data-content-on-scroll > *', {alpha: 0, y: 50})
    }

    typewriterAnimtion() {
        this.splitTextChar = new SplitText('#homepage-content h1', {type: "words,chars",reduceWhiteSpace:false});
        this.chars = this.splitTextChar.chars;

        gsap.from(this.chars, {opacity: 0, duration: 1, stagger: 0.05, ease: "expo.out"})
    }

    initScrollAnimation() {
        this.contentSections.forEach((section, sectionIndex) => {
            const elements = Array.from(section.children);
            // detect elements in viewport
            const visibleElements = elements.filter((element) => {
                const elementPosition = this.positionOf(element);
                const elementHeight = element.offsetHeight;
                const viewportHeight = window.innerHeight;
                return elementPosition < viewportHeight && elementPosition + elementHeight > 0;
            });

            // animate visible elements
            gsap.to(visibleElements, {
                opacity: 1,
                duration: 1,
                y: 0,
                ease: "power2.out",
                stagger: 0.2
            });

            const otherElements = elements.filter((element) => {
                return !visibleElements.includes(element);
            })

            otherElements.forEach((element) => {
                gsap.to(element, {
                    opacity: 1,
                    duration: 1,
                    y: 0,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 90%",
                        end: "bottom 10%",
                        once: true,
                    },
                });
            });
        });
    }

    positionOf(element) {
        let y = 0;
        while (element) {
            y += element.offsetTop;
            element = element.offsetParent;
        }
        return y;
    }
}

export default PageHomepage;
